import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=9d3c7b2e&scoped=true&"
import script from "./feed.vue?vue&type=script&lang=js&"
export * from "./feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3c7b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d3c7b2e')) {
      api.createRecord('9d3c7b2e', component.options)
    } else {
      api.reload('9d3c7b2e', component.options)
    }
    module.hot.accept("./feed.vue?vue&type=template&id=9d3c7b2e&scoped=true&", function () {
      api.rerender('9d3c7b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/header_block/notification/feed.vue"
export default component.exports